import { AdminFetchAppListAction, AdminFetchAppListEndAction } from "./FetchAppList";
import { AdminFetchAppStatsAction, AdminFetchAppStatsEndAction } from "./FetchAppStats";
import { AdminFetchStentorEventsAction, AdminFetchStentorEventsEndAction } from "./FetchStentorEvents";
import { AdminFetchVendorsAction, AdminFetchVendorsEndAction } from "./FetchVendors";
import { TransferAppAction, TransferAppEndAction } from "./TransferApp";
import { AdminUpdateAppAction, AdminUpdateAppEndAction } from "./UpdateApp";

export * from "./ErrorAction";
export * from "./FetchAppList";
export * from "./FetchAppStats";
export * from "./FetchStentorEvents";
export * from "./TransferApp";
export * from "./UpdateApp";
export * from "./FetchVendors";

export type AdminActions =
    | AdminFetchAppListAction
    | AdminFetchAppListEndAction
    | AdminUpdateAppEndAction
    | AdminUpdateAppAction
    | AdminFetchAppStatsAction
    | AdminFetchAppStatsEndAction
    | AdminFetchStentorEventsAction
    | AdminFetchStentorEventsEndAction
    | AdminFetchVendorsAction
    | AdminFetchVendorsEndAction
    | TransferAppAction
    | TransferAppEndAction;
